import ManualOrdersContainer from './manual-orders-container';

export default ManualOrdersContainer;
